/*
 * 首页
 *
 * @Author: xiaoJQ
 * @Date: 2024-05-15 16:25:35
 *
 * Copyright © 2024 kingdee.com. All Rights Reserved.
 */
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import positionStyles from 'components/position.less';
import { NavInfo } from 'components/util/navInfo';
import PopupWindow from 'components/popupWindow';
import { useSelector } from 'store/hook/useSelector';
import Icons from 'Icon/Icons.less';
import Styles from './index.less';
var navId2IconName = {
    create_extract: 'icon-add',
    history_extract: 'icon-history',
};
var HomePage = function () {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return state.control; }), operate = _a.operate, controlDisplay = _a.controlDisplay;
    var _b = useState(NavInfo[0].id), activeNav = _b[0], setActiveNav = _b[1];
    var _c = useState(null), interfaceRender = _c[0], setRender = _c[1];
    useEffect(function () {
        var operateInfo = NavInfo.find(function (item) { return item.id === operate; });
        if (operate && operateInfo) {
            setActiveNav(operate);
            setRender(operateInfo.render);
        }
    }, []);
    var handleChangeOperate = function (id, render) {
        dispatch({ type: 'changeOperate', payload: id });
        setActiveNav(id);
        setRender(render);
    };
    var operatingConsole = useMemo(function () {
        return function () { return (React.createElement("div", { className: Styles.operatingConsole },
            React.createElement("div", { className: classNames(Styles.navigationBar, positionStyles['between_center']) },
                React.createElement("div", { className: Styles.navigationBarConsole }, NavInfo.map(function (item) {
                    var _a;
                    return (React.createElement("div", { className: classNames(Styles.navItemWrapper, (_a = {},
                            _a[Styles.activeNav] = item.id === activeNav,
                            _a)), onClick: function () {
                            if (item.id !== activeNav) {
                                handleChangeOperate(item.id, item.render);
                            }
                        }, key: item.id },
                        React.createElement("span", { className: classNames(Styles.iconSize, Icons['icon'], Icons[navId2IconName[item.id]]) }),
                        React.createElement("span", null, item.title)));
                })),
                React.createElement("div", { className: Styles.introduction },
                    React.createElement("span", null, "\u89C6\u89C9\u8BC6\u522B\u670D\u52A1-\u6D41\u91CF\u7248\u6309\u63D0\u53D6\u8303\u56F4\u9875\u6570\u8BA1\u6B21\u6263\u8D39\uFF0C\u53EF\u8FDB\u5165\u89C6\u89C9\u8BC6\u522B\u670D\u52A1\u5E94\u7528\u67E5\u770B\u5269\u4F59\u6B21\u6570\u3002"))))); };
    }, [activeNav]);
    var operatingDisplay = useMemo(function () {
        return function () { return (React.createElement("div", { className: Styles.operatingDisplay }, interfaceRender)); };
    }, [interfaceRender]);
    return (React.createElement("div", { className: Styles.operatingInterface },
        controlDisplay ? operatingConsole() : null,
        operatingDisplay(),
        React.createElement(PopupWindow, null)));
};
export default HomePage;
